import ValidationRadio from './ValidationRadio';
import { ErrorMessage } from 'formik';

const ValidationRadioGroup = ({ name, labels, values, ...props }) => {
  return (
    <>
      {values.map((val, index) => (
        <ValidationRadio
          {...props}
          key={`${name}-radio-${index}`}
          name={name}
          label={labels[index]}
          value={val}
          className="mb-2 text-start"
        />
      ))}
      <ErrorMessage
        name={name}
        render={() => {
          return (
            <div
              className="text-start"
              style={{ display: 'block', float: 'left', color: '#dc3545', fontSize: '0.875em' }}
            >
              Please select an option
            </div>
          );
        }}
      />
    </>
  );
};

export default ValidationRadioGroup;
